/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { TimestampType } from '../../models/timestamp-type';

export interface GetAdministrationDeliveryNotesReportCsv$Params {
  organizationSiteKey: KeyType;
  from: TimestampType;
  to: TimestampType;
}

export function getAdministrationDeliveryNotesReportCsv(http: HttpClient, rootUrl: string, params: GetAdministrationDeliveryNotesReportCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationDeliveryNotesReportCsv.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/zip', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getAdministrationDeliveryNotesReportCsv.PATH = '/administration/organization-sites/{organizationSiteKey}/delivery-notes/reports/csv';
